import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface Props {
	providerRequest: DropdownRequest<ProductProviderItem>;
	value: number | number[] | null;
	mode: ControlMode;
	onChange: (provider: ProductProviderItem) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ProductProviderEditorView extends React.Component<Props, {}> {
	public render(): JSX.Element {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Product Provider';
		}

		const { mode, onChange, onGetErrorMessage, providerRequest, required, value } = this.props;
		return (
			<DropdownView
				onGetErrorMessage={onGetErrorMessage}
				label={label}
				model={value}
				disabled={mode == 'display'}
				onChanged={onChange}
				required={required}
				request={providerRequest}
				keyField="id"
				textField="name"
				placeholder="Select a Product Provider..."
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/parts/product-provider-editor.view.tsx